module.exports = __webpack_public_path__ + "img/style_3_0.6aab282e.png";